import React from 'react';
import PropTypes from 'prop-types';
//-----------------------------------------------------------------------------------------------
import './style.scss';

export const TalentCard = ({
  talentId,
  imageUrl,
  talentName,
  talentRole,
  onClick,
}) => (
  <div
    id={talentId}
    className="talent-card"
    onClick={onClick}
    aria-hidden="true"
  >
    <div className="talent-card__img">
      <img src={imageUrl} alt="clarovideo talento" />
    </div>
    <p className="talent-card__name">{talentName}</p>
    <p className="talent-card__role">{talentRole} </p>
  </div>
);

TalentCard.propTypes = {
  talentId: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
  talentName: PropTypes.string.isRequired,
  talentRole: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
